// extracted by mini-css-extract-plugin
module.exports = {"overlay":"BackgroundGradientBlur_overlay__n0T02","overlay--is-fixed":"BackgroundGradientBlur_overlay--is-fixed__Asg__"};